const subscription = {
    limit_exceeded: 'به محدودیت طرح اشتراک خود رسیده‌اید.',
    get_plan_failed: 'امکان دریافت طرح اشتراک برای مستأجر نیست.',
    tenant_suspended: 'مستأجر معلق است. لطفاً با مدیر خود تماس بگیرید.',
};
export default Object.freeze(subscription);
